module.exports = __webpack_public_path__ + "static/media/master_sanctuary.711b7e29.jpeg";